/**
 * WebserviceIntegracaoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {WebserviceIntegracao} from '@/model/resource/WebserviceIntegracao'

/* TODO: review generated class */
@HttpExclude()
export class WebserviceIntegracaoCollection extends PageCollection<
  WebserviceIntegracao
> {
  constructor() {
    super(WebserviceIntegracao)
  }

  queryAsPage() {
    return this.listWebserviceIntegracao()
  }

  async listWebserviceIntegracao() {
    return await Request.get(`/admin/webservice-integracao`, {
      params: this.params,
    })
      .name('listWebserviceIntegracao')
      .as(this)
      .getResponse()
  }

  async listCsvWebserviceIntegracao() {
    return await Request.get(`/admin/webservice-integracao/csv`, {
      params: this.params,
    })
      .name('listCsvWebserviceIntegracao')
      .as(this)
      .getResponse()
  }
}
